import * as React from 'react';
import { Typography } from '@material-ui/core';

import { Root, RouteList, Search } from '../containers';

const searchPage: React.SFC = () => {
  return (
    <Root routeList={<RouteList />}>
      <Typography variant="h5" gutterBottom>
        AI間違い指摘
      </Typography>
      <Search />
    </Root>
  );
};

export default searchPage;



// WEBPACK FOOTER //
// ./src/pages/search.tsx